import truncateHtml from './truncateHtml';

export const utils = {
  truncateHtml,
};
